import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import '../styles/article-widget.scss';

const ArticleCard = ({
    title,
    author,
    timeDiffText,
    inlineImage,
    readTime,
    imageCreds,
    eventName,
}) => {

    const [ t ] = useTranslation();

    return (
        <>
            <div className='long-article__image-container'>
                <div className='long-article__image-container--background' style={inlineImage}></div>
                <div className='long-article__image-container-image' style={inlineImage}></div>
            </div>
            <div className='long-article__content'>
                <span className='long-article__content-background'></span>
                {imageCreds ?
                    <span className='long-article__content-image-credits'>{`${t('long_articles_widget.image_credits')}${imageCreds}`}</span>
                    : null
                }
                {eventName ?
                    <span className='long-article__content-event-details'>{eventName}</span>
                    : null
                }
                <span className='long-article__content-title'>{title}</span>
                <div className='long-article__content-details'>
                    <span className='long-article__content-details-author'>{author}</span>
                    <span className='long-article__content-details-time'> - {`${timeDiffText}`}</span>
                </div>
                {readTime ?
                    <span className='long-article__content-read-time'>{`${t('long_articles_widget.read_time', {readTime})}`}</span>
                    : null
                }
            </div>
        </>
    );

};

ArticleCard.propTypes = {
    title: PropTypes.string,
    author: PropTypes.string,
    timeDiffText: PropTypes.string,
    inlineImage: PropTypes.object,
    readTime: PropTypes.number,
    imageCreds: PropTypes.string,
    eventName: PropTypes.string,
};

ArticleCard.defaultProps = {
    title: '',
    author: '',
    timeDiffText: '',
    inlineImage: {},
    readTime: null,
    imageCreds: null,
};

export default ArticleCard;
